/* @flow */

export const SET_CURRENT_USER = '@current-user/SET_CURRENT_USER';
export const LOGOUT = '@current-user/LOGOUT';



// WEBPACK FOOTER //
// ./src/redux/current-user/actionTypes.js